// extracted by mini-css-extract-plugin
export default {"main":"LottiePlayer_main__dzgO3"};